module.exports = __webpack_public_path__ + "fonts/e88197d.ttf";